export default "__VITE_ASSET__C$3gisbb__"